export enum SourceFunds {
    HERITAGE = 'PA',
    SALARIES = 'SA',
    REAL_ESTATE_SALES = 'VP',
    INHERITANCE_OR_SAVINGS = 'HH',
    OTHER = 'TR',
}
